import { Reducer } from "redux";
import { SectionState, Section } from "./@types";
import { TAction } from "loop-front";
import { OSection } from "./Model";
import utilities from "../../Resources/Utils";

export const Sections: Reducer<SectionState, TAction> = (state: SectionState = { mainList: [] }, action: TAction) => {
    switch (action.type) {
        case OSection.Actions.LIST_RECEIVED: return { ...state, mainList: action.data }

        case OSection.Actions.POST_ITEM_SUCCESS:
        case OSection.Actions.PUT_ITEM_SUCCESS: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }

        case OSection.Actions.ITEM_DELETED: return { ...state, mainList: utilities.updateItemList(state.mainList || [], { id: action.additionalDispatchData.deletedItemId } as Section, 'DELETE') }

        case OSection.Actions.ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case OSection.Activities.TOGGLE_PUBLISH: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }
                default: return state;
            }
        }

        default: return state;
    }
}